const mutations = {
    SET_ERROR_PRODUCTS(state, payload) {
        state.error = payload;
    }
};

export default mutations;
